import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import slugify from "react-slugify";
import { ApiLinkContext } from "../context/ApiLinkContext";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";

const NewsDetails = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const { blogCat, blog, loading, error } = useContext(ApiLinkContext);
  const { newsDetailsId } = useParams();
  

  const findNews = blog.find(
    (item) => slugify(`${item.id}-${item.name}`).toLowerCase() === newsDetailsId
  );
  useEffect(()=>{
   if (findNews) {
    axios.post(`https://www.turanozbahceci.com/api/view.php`,{
      id:findNews && findNews.id
    })
    .then((res)=>{
      console.log(res);
    })
    .catch((err)=>{
      console.log(err);
    })
   }
   
  },[findNews,newsDetailsId])
 
  return (
    <>
      <div className="section py-5">
        <div className="container">
          <div className="row max-mb-n50">
            {findNews && (
              <div className="col-lg-8 col-12 order-lg-1 max-mb-50">
                {/* Course Details Wrapper Start */}

                <div className="course-details-wrapper">
                  <div className="tab-content">
                    <div id="overview" className="tab-pane fade show active">
                      <div className="course-overview">
                        <h3 className="title">  {language == "az"
                                  ? findNews.name
                                  : language == "en"
                                  ? findNews.nameEn
                                  : language == "ru"
                                  ? findNews.nameRu
                                  : language == "tr"
                                  ? findNews.nameTr
                                  : language == "de"
                                  ? findNews.nameDe
                                  : language == "pl"
                                  ? findNews.namePl
                                  : ""}</h3>
                        <div className="detailsView d-flex justify-content-between">
                          <div>
                            <i class="fa-solid fa-calendar-days me-2"></i>
                            <span>{findNews.date}</span>
                          </div>
                          <div>
                            <i className="fa-solid fa-eye me-2"></i>
                            <span>{findNews.view}</span>
                          </div>
                        </div>

                        <img
                          src={findNews.img}
                          alt=""
                          className="img-fluid w-100 py-3"
                        />
                        <p
                          dangerouslySetInnerHTML={{
                            __html:
                              language == "az"
                                ? findNews.text
                                : language == "en"
                                ? findNews.textEn
                                : language == "ru"
                                ? findNews.textRu
                                : language == "tr"
                                ? findNews.textTr
                                : language == "de"
                                ? findNews.textDe
                                : language == "pl"
                                ? findNews.textPl
                                : "",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="col-lg-4 col-12 order-lg-2 max-mb-50">
              <div className="sidebar-widget-wrapper pl-30 pl-md-0 pl-sm-0 pl-xs-0">
                <div className="sidebar-widget">
                  <h3 className="sidebar-widget-title">{t.othernew}</h3>
                  <div className="sidebar-widget-content">
                    <ul className="sidebar-widget-course">
                      {blog
                        .filter((i) => i.id !== findNews.id)
                        .slice(0, 6)
                        .map((item) => {
                          return (
                            <NavLink
                              to={`/${slugify(
                                `${item.id}-${item.name}`
                              ).toLowerCase()}`}
                              onClick={() => window.scrollTo({ top: 0 })}
                            >
                              <li className="widget-course">
                                <div className="thumbnail">
                                  <img
                                    src={item.img}
                                    alt="Course Image"
                                    className="img-fluid"
                                    style={{ objectFit: "cover" }}
                                  />
                                </div>
                                <div className="info">
                                  <h6 className="title">
                                    <a href="#">
                                      {language == "az"
                                        ? item.name
                                        : language == "en"
                                        ? item.nameEn
                                        : language == "ru"
                                        ? item.nameRu
                                        : language == "tr"
                                        ? item.nameTr
                                        : language == "de"
                                        ? item.nameDe
                                        : language == "pl"
                                        ? item.namePl
                                        : ""}
                                    </a>
                                  </h6>
                                  <div className="d-flex">
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html:
                                           item.text && 
                              
                                            language == "az"
                                                    ? item.text.slice(0,81)
                                                    : language == "en"
                                                    ? item.textEn.slice(0,81)
                                                    : language == "ru"
                                                    ? item.textRu.slice(0,81)
                                                    : language == "tr"
                                                    ? item.textTr.slice(0,81)
                                                    : language == "de"
                                                    ? item.textDe.slice(0,81)
                                                    : language == "pl"
                                                    ? item.textPl.slice(0,81)
                                                    : "",
                                      }}
                                    />{" "}
                                   
                                  </div>
                                </div>
                              </li>
                            </NavLink>
                          );
                        })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsDetails;
